export const cockpitMenuPaperClassName = 'cockpit-menu-paper';
export const cockpitMenuItemClassName = 'cockpit-menu-item';

export const cockpitMenuPaperSx = {
  mt: 0.75,
  p: 0.5,
  width: 220,
  minWidth: 220,
  color: 'var(--cockpit-text) !important',
  backgroundColor: 'var(--cockpit-surface)',
  border: '1px solid var(--cockpit-border)',
  borderRadius: 'var(--cockpit-radius-small)',
  boxShadow: 'var(--cockpit-shadow)'
};

export const cockpitMenuItemSx = {
  px: 1.25
};
